<template>
    <v-container>
        <ModuleBar title="ADMINISTRAR MISIONES" />

        <v-row v-if="loadingSearch">
            <v-col class=" mt-10 d-flex justify-center">
                <v-progress-circular indeterminate size="60" width="2" color="primary" />
            </v-col>
        </v-row>

        <v-card outlined class="mt-10" v-if="missions">
            <v-card-text>
                <v-list>
                    <v-list-item-group color="primary">
                        <template v-for="mission, key in missions">
                            <v-list-item :key="key" v-if="missions" @click="openDialogMission(mission, 'edit')">

                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ mission.avatar.toUpperCase() }}
                                        <v-icon size="16" :color="mission.enabled ? `green` : `red`">mdi-circle</v-icon>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>{{ mission.address }}</v-list-item-subtitle>
                                    <v-list-item-subtitle>{{ mission.description }}</v-list-item-subtitle>
                                    <v-list-item-subtitle>Registrada: {{ mission.created_at }}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider :key="`key${key}`" v-if="key != missions.length - 1" />
                        </template>
                    </v-list-item-group>
                </v-list>
            </v-card-text>
        </v-card>

        <v-dialog width="1000" v-model="dialogMission" persistent>
            <v-card>
                <v-card-text>
                    <mission-form title="INFORMACION DE LA MISION" :mission="mission" schema="edit" :click="click"
                        @closeDialogMission="closeDialogMission" @updateMission="updateMission"
                        @deleteMission="deleteMission" />
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import ModuleBar from '../../components/General/ModuleBar.vue';
import MissionForm from "../../components/Forms/missionForm.vue";

export default {
    props: ['type', 'withTitle'],

    components: { ModuleBar, MissionForm },

    beforeMount() {
        this.search();
    },

    data() {
        return {
            click: 0,
            dialogMission: false,
            isSearch: false,
            loadingSearch: false,
            params: "",
            missions: null,
            mission: null,
        };
    },

    watch: {
        click() {
            this.search();
        }
    },

    methods: {
        search() {
            this.missions = null;
            this.loadingSearch = true;
            this.isSearch = true;

            let payload = {
                params: this.type
            }

            setTimeout(() => {
                this.$store.dispatch("findAllMissionAction", payload).then((res) => {
                    this.missions = res;
                    this.loadingSearch = false;
                    this.isSearch = false;
                }).catch(() => {
                    this.loadingSearch = false;
                    this.isSearch = false;
                })
            }, 500);
        },

        openDialogMission(mission, schema) {
            this.schema = schema;
            this.dialogMission = true;
            this.mission = mission;
            this.click++;
        },

        closeDialogMission() {
            this.dialogMission = false;
        },

        updateMission(mission) {
            let index = this.missions.findIndex((x) => x.id == mission.id);
            mission.enabled = parseInt(mission.enabled)

            if (index >= 0) {
                this.missions[index] = mission;
            }
        },

        deleteMission(missionId) {
            this.dialogMission = false;
            let index = this.missions.findIndex((x) => x.id == missionId.id);
            if (index >= 0) {
                this.missions.splice(index, 1);
            }
        }
    },
}
</script>